import React, { useEffect, useState } from "react";
import "./orderStatusButton.scss";
import { styled, alpha } from "@mui/material/styles";
import { LoadingButton } from "@mui/lab";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import orderStore from "../../stores/orderStore";
import orderDeliveryStatusTimeStore from "../../stores/orderDeliveryStatusTimeStore";
import orderReturnRequestStore from "../../stores/orderReturnRequestStore";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const OrderStatusButton = ({
  buttonName,
  paymentID,
  history,
  returnProduct,
  productLength,
}) => {
  const OrderStore = orderStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();
  const OrderReturnRequestStore = orderReturnRequestStore();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const statuses = [
    {
      name: "Pending",
      date: history.pending,
    },
    {
      name: "Preparing",
      date: history.preparing,
    },
    {
      name: "In Transit",
      date: history.in_transit,
    },
    {
      name: "Out Of Delivery",
      date: history.out_of_delivery,
    },
    {
      name: "Delivered",
      date: history.delivered,
    },
    {
      name: "Cancelled",
      date: history.cancelled,
    },
    {
      name: "Return",
      date: history.returning,
    },
  ];

  const [isLoading, setIsLoading] = useState(false);

  const handlePublish = async (item) => {
    setAnchorEl(null);
    setIsLoading(true);
    let preparing = history.preparing;
    let in_transit = history.in_transit;
    let out_of_delivery = history.out_of_delivery;
    let delivered = history.delivered;
    let returning = history.returning;
    let cancelled = history.cancelled;

    if (item.name === "Preparing") {
      preparing = new Date();
    } else if (item.name === "In Transit") {
      in_transit = new Date();
    } else if (item.name === "Out Of Delivery") {
      out_of_delivery = new Date();
    } else if (item.name === "Delivered") {
      delivered = new Date();
    } else if (item.name === "Return") {
      returning = new Date();
    } else if (item.name === "Cancelled") {
      cancelled = new Date();
    }

    await OrderStore.updateDeliveryStatus({
      paymentID,
      order_delivery_status: item.name,
    });

    await OrderDeliveryStatusTimeStore.updateOrderDeliveryStatusTime({
      _id: history._id,
      preparing,
      in_transit,
      out_of_delivery,
      delivered,
      returning,
      cancelled,
    });

    if (item.name === "Return") {
      for (let i = 0; i < returnProduct.length; i++) {
        await OrderReturnRequestStore.updateReturningStatus({
          id: returnProduct[i]._id,
          order_returning_status: false,
        });
      }
    }

    setIsLoading(false);
  };

  return (
    <div className="order-status-button">
      <LoadingButton
        loading={isLoading}
        disabled={history.cancelled}
        className="btn"
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="outlined"
        disableElevation
        style={{ background: isLoading && "#f5f5f5", color: history.cancelled && "white" }}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {buttonName === "Return"
          ? history.returning === null
            ? "Returning"
            : buttonName
          : buttonName}
      </LoadingButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {statuses.map((item) => {
          if (
            returnProduct.length &&
            item.name === "Return" &&
            productLength === returnProduct.length
          ) {
            if (
              returnProduct[0].order_returning_status ||
              returnProduct[0].order_return_status
            ) {
              return (
                <MenuItem
                  key={item.name}
                  disabled={item.date && true}
                  sx={{ bgcolor: item.date && "var(--babyBlue)" }}
                  onClick={() => handlePublish(item)}
                >
                  {item.name}
                </MenuItem>
              );
            }
          } else {
            if (item.name !== "Return") {
              return (
                <MenuItem
                  key={item.name}
                  disabled={item.date && true}
                  sx={{ bgcolor: item.date && "var(--babyBlue)" }}
                  onClick={() => handlePublish(item)}
                >
                  {item.name}
                </MenuItem>
              );
            }
          }
        })}
      </StyledMenu>
    </div>
  );
};

export default OrderStatusButton;
